import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IssuesDashboardModule } from '@features/issues-dashboard';
import { MimicUserModule } from '@features/mimic-user';
import { SecurityModule } from '@features/security';
import { SharedModule } from '@shared';
import {
  HomeOrganizationComponent,
  IssuesStatusInfoComponent,
  MenuOrganizationsComponent,
  PageOrganizationComponent,
  PageOrganizationsComponent,
  ProductTileOrganizationsComponent,
  StatisticsTileOrganizationsComponent,
  StatusTableOrganizationsComponent,
  ZendeskTicketsTableComponent,
} from './components';
import { OrganizationsRoutingModule } from './organizations-routing.module';
import { InternalUserOrganizationResolver } from './resolver';

@NgModule({
  declarations: [
    PageOrganizationsComponent,
    PageOrganizationComponent,
    StatisticsTileOrganizationsComponent,
    ProductTileOrganizationsComponent,
    StatusTableOrganizationsComponent,
    MenuOrganizationsComponent,
    HomeOrganizationComponent,
    ZendeskTicketsTableComponent,
    IssuesStatusInfoComponent,
  ],
  providers: [InternalUserOrganizationResolver],
  exports: [MenuOrganizationsComponent, PageOrganizationsComponent],
  imports: [
    CommonModule,
    SharedModule,
    MimicUserModule,
    OrganizationsRoutingModule,
    ReactiveFormsModule,
    SecurityModule,
    IssuesDashboardModule,
  ],
})
export class OrganizationsModule {}
